// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Education and Work Experience dialogs. Warm antique-white card to match the
   site, with a clean sans-serif for reading (the site-wide stylesheet forces a
   thin monospace on everything, which is too faint for paragraphs). */

.info-modal {
  --info-surface: #fffaf1;
  --info-line: #e7d5bb;
  --info-text: #241c12;
  --info-muted: #7a6b57;
  --info-accent: #b8420c;
}
.info-modal,
.info-modal * {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}
.info-modal .modal-content {
  border: 0;
  border-radius: 1rem;
  background: var(--info-surface);
  color: var(--info-text);
  box-shadow: 0 24px 60px rgba(36, 28, 18, 0.3);
  overflow: hidden;
}

/* Header */
.info-modal .modal-header {
  align-items: center;
  padding: 1.4rem 1.75rem 1.1rem;
  border-bottom: 1px solid var(--info-line);
}
.info-modal .modal-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--info-text);
}
.info-modal .modal-header .close {
  margin: 0;
  padding: 0.25rem 0.5rem;
  color: var(--info-muted);
  font-size: 1.75rem;
  font-weight: 300;
  line-height: 1;
  text-shadow: none;
  opacity: 1;
}
.info-modal .modal-header .close:hover {
  color: var(--info-accent);
}

/* Body */
.info-modal .modal-body {
  padding: 0.5rem 1.75rem 1.75rem;
}
.info-entry {
  padding: 1.4rem 0;
  border-bottom: 1px solid var(--info-line);
}
.info-entry:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}
.info-entry-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem 1.25rem;
  margin-bottom: 0.75rem;
}
.info-modal .info-kicker {
  margin: 0 0 0.35rem;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--info-accent);
}
.info-modal .info-org {
  margin: 0;
  font-size: 1.1875rem;
  font-weight: 700;
  line-height: 1.3;
  color: var(--info-text);
}
.info-modal .info-meta {
  margin: 0.15rem 0 0;
  font-size: 0.9375rem;
  color: var(--info-muted);
}
.info-modal .info-dates {
  flex-shrink: 0;
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--info-accent);
}
.info-modal .info-list {
  margin: 0.75rem 0 0;
  padding-left: 1.1rem;
  font-size: 0.9375rem;
  line-height: 1.65;
  color: var(--info-text);
}
.info-entry-head + .info-list {
  margin-top: 0;
}
.info-modal .info-list li {
  margin-bottom: 0.55rem;
  padding-left: 0.15rem;
}
.info-modal .info-list li:last-child {
  margin-bottom: 0;
}
.info-modal .info-list li::marker {
  color: var(--info-accent);
}
.info-modal .info-list ul {
  margin-top: 0.4rem;
  padding-left: 1.1rem;
  color: var(--info-muted);
}

/* Phones */
@media (max-width: 40rem) {
  .info-modal .modal-header {
    padding: 1.1rem 1.25rem 0.9rem;
  }
  .info-modal .modal-title {
    font-size: 1.25rem;
  }
  .info-modal .modal-body {
    padding: 0.25rem 1.25rem 1.5rem;
  }
  .info-entry-head {
    flex-direction: column;
    gap: 0.35rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/Modals/infoModal.css"],"names":[],"mappings":"AAAA;;sEAEsE;;AAEtE;EACE,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;EAEE,gGAAgG;AAClG;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;AAC3C;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,yCAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,sBAAsB;IACtB,YAAY;EACd;AACF","sourcesContent":["/* Education and Work Experience dialogs. Warm antique-white card to match the\n   site, with a clean sans-serif for reading (the site-wide stylesheet forces a\n   thin monospace on everything, which is too faint for paragraphs). */\n\n.info-modal {\n  --info-surface: #fffaf1;\n  --info-line: #e7d5bb;\n  --info-text: #241c12;\n  --info-muted: #7a6b57;\n  --info-accent: #b8420c;\n}\n.info-modal,\n.info-modal * {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n}\n.info-modal .modal-content {\n  border: 0;\n  border-radius: 1rem;\n  background: var(--info-surface);\n  color: var(--info-text);\n  box-shadow: 0 24px 60px rgba(36, 28, 18, 0.3);\n  overflow: hidden;\n}\n\n/* Header */\n.info-modal .modal-header {\n  align-items: center;\n  padding: 1.4rem 1.75rem 1.1rem;\n  border-bottom: 1px solid var(--info-line);\n}\n.info-modal .modal-title {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--info-text);\n}\n.info-modal .modal-header .close {\n  margin: 0;\n  padding: 0.25rem 0.5rem;\n  color: var(--info-muted);\n  font-size: 1.75rem;\n  font-weight: 300;\n  line-height: 1;\n  text-shadow: none;\n  opacity: 1;\n}\n.info-modal .modal-header .close:hover {\n  color: var(--info-accent);\n}\n\n/* Body */\n.info-modal .modal-body {\n  padding: 0.5rem 1.75rem 1.75rem;\n}\n.info-entry {\n  padding: 1.4rem 0;\n  border-bottom: 1px solid var(--info-line);\n}\n.info-entry:last-child {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n.info-entry-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.5rem 1.25rem;\n  margin-bottom: 0.75rem;\n}\n.info-modal .info-kicker {\n  margin: 0 0 0.35rem;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--info-accent);\n}\n.info-modal .info-org {\n  margin: 0;\n  font-size: 1.1875rem;\n  font-weight: 700;\n  line-height: 1.3;\n  color: var(--info-text);\n}\n.info-modal .info-meta {\n  margin: 0.15rem 0 0;\n  font-size: 0.9375rem;\n  color: var(--info-muted);\n}\n.info-modal .info-dates {\n  flex-shrink: 0;\n  margin: 0;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: var(--info-accent);\n}\n.info-modal .info-list {\n  margin: 0.75rem 0 0;\n  padding-left: 1.1rem;\n  font-size: 0.9375rem;\n  line-height: 1.65;\n  color: var(--info-text);\n}\n.info-entry-head + .info-list {\n  margin-top: 0;\n}\n.info-modal .info-list li {\n  margin-bottom: 0.55rem;\n  padding-left: 0.15rem;\n}\n.info-modal .info-list li:last-child {\n  margin-bottom: 0;\n}\n.info-modal .info-list li::marker {\n  color: var(--info-accent);\n}\n.info-modal .info-list ul {\n  margin-top: 0.4rem;\n  padding-left: 1.1rem;\n  color: var(--info-muted);\n}\n\n/* Phones */\n@media (max-width: 40rem) {\n  .info-modal .modal-header {\n    padding: 1.1rem 1.25rem 0.9rem;\n  }\n  .info-modal .modal-title {\n    font-size: 1.25rem;\n  }\n  .info-modal .modal-body {\n    padding: 0.25rem 1.25rem 1.5rem;\n  }\n  .info-entry-head {\n    flex-direction: column;\n    gap: 0.35rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
